import React, { forwardRef } from "react";
import PropTypes from "prop-types";

const FeaturedIcon = forwardRef(
  (
    {
      icon = (
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 1L1.5 7H6L5.5 11L10.5 5H6L6.5 1Z"
            stroke="#F55533"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      color = "primary",
      theme = "lightCircle",
      className = "",
      size = "sm",
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={`featured-icon-container ${size} ${color} ${theme} ${className}`}
        ref={ref}
        {...props}
      >
        {icon}
      </div>
    );
  }
);

export default FeaturedIcon;

FeaturedIcon.propTypes = {
  icon: PropTypes.node,
  color: PropTypes.oneOf(["primary", "gray", "error", "warning", "success"]),
  theme: PropTypes.oneOf([
    "lightCircle",
    "lightCircleOutline",
    "darkCircle",
    "lightSquare",
    "midSquare",
    "darkSquare",
    "modern",
  ]),
  className: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "2xl"]),
};
